import {
  AppDispatch,
  createKitClear,
  deleteKitDevice,
  deleteKitDeviceClear,
  dynamicSet,
  getKitList,
  getKitListRequest,
  getSubscriptionPlanList,
  getSubscriptionPlanListRequest,
  Kit,
  setKitSubscription,
  setKitSubscriptionClear,
  setKitSubscriptionRequest,
  updateKitClear,
  useDynamicSelector,
} from "@src/redux";
import {
  Button,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  Modal,
  Row,
  Select,
} from "antd";
import { AiFillEdit } from "react-icons/ai";
import { MdOutlineSubscriptions } from "react-icons/md";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientKitCardFooter from "./ClientKitCardFooter";
import ClientKitCardHeader from "./ClientKitCardHeader";
import ClientKitCardContent from "./ClientKitCardContent";
import ClientKitForm from "./client-kit-form/ClientKitForm";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import TextArea from "antd/es/input/TextArea";
type Props = {};

const ClientKitList = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const { t } = useTranslation();
  const [kitItems, setKitItems] = useState<Kit[]>([]);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [selectedKit, setSelectedKit] = useState<Kit | null>(null);
  const { result: plans } = useSelector(getSubscriptionPlanList);
  const {
    result: deleteKitDeviceResult,
    error: deleteKitDeviceResultError,
    loading: deleteKitDeviceResultLoading,
  } = useSelector(deleteKitDevice);

  const { modal: isSubscriptionModalVisible } = useDynamicSelector(
    "subscription_plan_modal"
  );
  const { kit } = useDynamicSelector("set_kit");

  const {
    result: setKitSubscriptionResult,
    loading: setKitSubscriptionLoading,
  } = useSelector(setKitSubscription);
  const [form] = Form.useForm();

  const { result, loading, error } = useSelector(getKitList);

  useEffect(() => {
    dispatch(getSubscriptionPlanListRequest({}));
    // getDeviceList();
  }, [id]);

  useEffect(() => {
    if (result?.items?.length) {
      setKitItems(result.items);
    } else {
      setKitItems([]);
    }
  }, [result]);

  const handleCancel = () => {
    setIsModalVisible(false);
    dispatch(createKitClear());
    dispatch(updateKitClear());
  };

  const handleOpen = (kit: Kit) => {
    setSelectedKit(kit);
    setIsModalVisible(true);
  };

  const getKitLists = () => {
    dispatch(
      getKitListRequest({
        filter: {
          searchString: "",
          // operatorId: "",
          organizationId: id,
        },
      })
    );
  };

  useEffect(() => {
    if (setKitSubscriptionResult?.status === "success") {
      toast.success("Subscription Added");
      dispatch(dynamicSet("subscription_plan_modal", { modal: false }));
      getKitLists();
      form.resetFields();
      dispatch(setKitSubscriptionClear());
    } else if (setKitSubscriptionResult?.error?.message) {
      toast.error(setKitSubscriptionResult?.error.message);
      dispatch(setKitSubscriptionClear());
    }
  }, [setKitSubscriptionResult]);
  useEffect(() => {
    if (deleteKitDeviceResult?.status === "success") {
      toast.success("Device removed Successfully");
      dispatch(deleteKitDeviceClear());
    } else if (deleteKitDeviceResult?.error?.message) {
      toast.error(deleteKitDeviceResult?.error.message);
      dispatch(deleteKitDeviceClear());
    }
  }, [deleteKitDeviceResult]);

  const handleSubmit = (values: any) => {
    const notificationEmails: string[] = (values?.notificationEmails || "")
      .split(/[,;\s]+/)
      .map((s: string) => s.trim())
      .filter((s: string) => s.length > 0);
    const payload = {
      subscriptionId: values.subscriptionId,
      effectiveFrom: values.effectiveFrom,
      remark: values.remark,
      notificationEmails,
    };
    dispatch(
      setKitSubscriptionRequest({
        data: payload,
        id: kit.id,
      })
    );
  };

  const handleSetCancel = () => {
    dispatch(dynamicSet("subscription_plan_modal", { modal: false }));
    form.resetFields();
  };
  return (
    <div className="client-kit-container">
      {loading && (
        <div className="inline-loading-wrap">
          <div className="inline-loading-spinner" />
          <div className="inline-loading-text">{t("loading") || "Loading kits..."}</div>
        </div>
      )}
      {!loading && kitItems?.length === 0 && (
        <Row
          justify="center"
          align="middle"
          style={{ marginTop: "40px", width: "100%" }}
        >
          <Col>
            <Empty description={t("kit_not_found")} />
          </Col>
        </Row>
      )}
      {!loading &&
        kitItems.map((kit, index) => {
          return (
            <div className="client-kit-container-card" key={index}>
              <ClientKitCardHeader handleOpen={handleOpen} kit={kit} />
              <ClientKitCardContent kit={kit} />
              <ClientKitCardFooter
                kit={kit}
                getKitLists={getKitLists}
                form={form}
              />
            </div>
          );
        })}
      <Modal
        className="kit-edit-modal"
        title={
          <span className="kit-edit-modal-title">
            <AiFillEdit style={{ marginRight: 8, verticalAlign: "-3px" }} />
            Edit Kit
          </span>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        destroyOnClose
        footer={null}
        width={520}
        centered
      >
        {selectedKit && (
          <ClientKitForm
            handleCancel={handleCancel}
            modalType="edit"
            mutationType="edit"
            kit={selectedKit}
            getKitLists={getKitLists}
          />
        )}
      </Modal>
      <Modal
        className="kit-edit-modal"
        title={
          <span className="kit-edit-modal-title">
            <MdOutlineSubscriptions style={{ marginRight: 8, verticalAlign: "-3px" }} />
            Kit Subscription
          </span>
        }
        open={isSubscriptionModalVisible || false}
        onCancel={handleSetCancel}
        footer={null}
        width={520}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          name="subscriptionForm"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Subscription Type"
            name="subscriptionId"
            rules={[
              { required: true, message: "Please select a subscription type!" },
            ]}
          >
            <Select
              style={{ width: "100%" }}
              options={plans?.items || []}
              fieldNames={{
                label: "name",
                value: "id",
              }}
            />
          </Form.Item>

          {/* DatePicker Field */}
          <Form.Item
            label="Effective From"
            name="effectiveFrom"
            rules={[{ required: true, message: "Please select a date!" }]}
          >
            <DatePicker
              placeholder=""
              style={{ width: "100%" }}
              format={"DD-MMM-YYYY"}
            />
          </Form.Item>

          {/* Notification Emails Field */}
          <Form.Item
            label="Notification Email(s)"
            name="notificationEmails"
            extra="Reminder is sent to these addresses 15 days before kit expiry. Separate multiple addresses with comma."
            rules={[
              {
                validator: (_: any, value: string) => {
                  if (!value) return Promise.resolve();
                  const parts = value
                    .split(/[,;\s]+/)
                    .map((s: string) => s.trim())
                    .filter((s: string) => s.length > 0);
                  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  const bad = parts.find((p: string) => !re.test(p));
                  if (bad) {
                    return Promise.reject(
                      new Error(`Invalid email: ${bad}`)
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="user@example.com, ops@example.com" />
          </Form.Item>

          {/* Remarks Field */}
          <Form.Item label="Remarks" name="remark">
            <TextArea rows={4} placeholder="" />
          </Form.Item>
          <div className="kit-edit-modal-footer">
            <Button type="default" danger onClick={handleSetCancel}>
              {t("close")}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={setKitSubscriptionLoading}
            >
              {t("submit")}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ClientKitList;
